<template>

    <div>

        <v-icon class="mr-3">mdi-magnify</v-icon>

        <gmap-autocomplete class="input" :placeholder="$t('edit_areas.search_address')" @place_changed="updateCenter($event)"></gmap-autocomplete>

    </div>
  
</template>

<script>
import { mapMutations } from 'vuex'
import { SET_CENTER_MAP, SET_ZOOM } from '../../../store/mutations'

export default {

    name: 'InputGmapAutocomplete',

    methods: {

        ...mapMutations({ 

            setZoom: `AreaVuex/${SET_ZOOM}`, 
            setMapCenter: `AreaVuex/${SET_CENTER_MAP}`, 

        }),


        async updateCenter(newCoord) {

            const lat = newCoord.geometry.location.lat()
            const lng = newCoord.geometry.location.lng()

            this.setMapCenter({ lat, lng })
            this.setZoom(15)


        },
    },

}
</script>

<style>

</style>